var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 32,
    viewBox: "0 0 377 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 25.5L22.5 6L42 25.5L61.5 6L81 25.5L100.5 6L120 25.5L139.5 6L159 25.5L178.5 6L198 25.5L217.5 6L237 25.5L256.5 6L276 25.5L295.5 6L315 25.5L334.5 6L354 25.5L373.5 6",
    stroke: "#F2411F",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZig);
export default __webpack_public_path__ + "static/media/zig.66ddf47278230cac28f374b83e11f981.svg";
export { ForwardRef as ReactComponent };